// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CJNc9","right":"styles_right__pps1_"};